// src/contexts/ExamensContext.jsx
import { createContext, useContext, useState } from 'react';

export const ExamensContext = createContext();

export const useExamensContext = () => {
  const context = useContext(ExamensContext);
  if (!context) {
    throw new Error('useExamensContext doit être utilisé dans ExamensProvider');
  }
  return context;
};

export const ExamensProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    console.log('🔄 Déclenchement du rafraîchissement du dashboard');
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <ExamensContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </ExamensContext.Provider>
  );
};